import {
  IconDefinition,
  faArrowDownTriangleSquare,
  faArrowRight,
  faCircleExclamation,
  faLoader,
  faTimer,
} from '@fortawesome/pro-regular-svg-icons';
import { TicketStatus } from '@vision/ui/enums';

export interface TicketStatusButtonConfig {
  bg: string;
  fg: string;
  icon: IconDefinition;
  iconSpin?: boolean;
}

export const TicketStatusButtonConfigByStatus: Record<TicketStatus, TicketStatusButtonConfig> = {
  [TicketStatus.OPEN]: {
    bg: 'yellow.0',
    fg: 'yellow.8',
    icon: faArrowRight,
  },
  [TicketStatus.IN_PROGRESS]: {
    bg: 'orange.0',
    fg: 'orange.6',
    icon: faLoader,
    iconSpin: true,
  },
  [TicketStatus.WAITING]: {
    bg: 'teal.0',
    fg: 'teal.6',
    icon: faTimer,
  },
  [TicketStatus.ESCALATED]: {
    bg: 'red.0',
    fg: 'red.9',
    icon: faCircleExclamation,
  },
  [TicketStatus.CLOSED]: {
    bg: 'green.0',
    fg: 'green.6',
    icon: faArrowDownTriangleSquare,
  },
  [TicketStatus.REOPENED]: {
    bg: 'blue.0',
    fg: 'blue.6',
    icon: faArrowRight,
  },
};
